import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

class GetCitiesListAction extends BaseAction<void, any> {
    override async run(): Promise<any> {
        let cities: any = []
        try {
            if (this.result == null) {
                cities = [
                    { id: 1, value: "dubai", label: "Dubai", labelTranslationKey: "Dubai" },
                    { id: 2, value: "abu-dhabi", label: "Abu Dhabi", labelTranslationKey: "Abu Dhabi" },
                    { id: 3, value: "sharjah", label: "Sharjah", labelTranslationKey: "Sharjah" },
                    { id: 4, value: "ajman", label: "Ajman", labelTranslationKey: "Ajman" },
                    { id: 5, value: "al-ain", label: "Al Ain", labelTranslationKey: "Al Ain" },
                    { id: 6, value: "ras-al-khaimah", label: "Ras Al Khaimah", labelTranslationKey: "Ras Al Khaimah" },
                    { id: 7, value: "fujairah", label: "Fujairah", labelTranslationKey: "Fujairah" }
                ]
                updateRecoilState("citiesAtom", cities)
            }
        } catch (error: any) {
            console.error("Error fetching Cities :", error);
        }
        finally {
            return cities
        }
    }
}

export const getCitiesListAction = new GetCitiesListAction()


